import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByDateTime',
    standalone: false
})
export class SortByDateTimePipe implements PipeTransform {

  transform(appointments: any[]): any[] {
    return appointments.sort((a, b) => {
      let dateA = new Date(a.aptTime);
      let dateB = new Date(b.aptTime);

      return dateA.getTime() - dateB.getTime();
    });
  }

}
